import * as moment from 'moment';
import { StringHelper } from './StringHelper';

export class DateHelper {
    public static getMomentDate(date: string): moment.Moment {
        if (date === null) {
            return moment();
        } else {
            return moment(date.split('T')[0]);
        }
    }

    public static getMomentDateOnly(date: moment.Moment): moment.Moment {
        return date.clone().startOf('day');
    }

    public static getNullbleMomentDate(date: string): moment.Moment {
        if (date === null) {
            return null;
        } else {
            return moment(date.split('T')[0]);
        }
    }

    public static getLocalDateInMoment(date: string): moment.Moment {
        if (date === null) {
            const today = new Date();
            return this.getMomentDate(
                this.getUTCDateString(
                    new Date(
                        Date.UTC(
                            today.getFullYear(),
                            today.getMonth(),
                            today.getDate()
                        )
                    )
                )
            );
        } else {
            const dateComponents = date.split('T')[0].split('-');
            const timeComponents = date.split('T')[1].split(':');
            const tempDate = new Date(
                Number(dateComponents[0]),
                Number(dateComponents[1]) - 1,
                Number(dateComponents[2]),
                Number(timeComponents[0]),
                Number(timeComponents[1])
            );
            const localNativeDate = new Date(
                Date.UTC(
                    tempDate.getFullYear(),
                    tempDate.getMonth(),
                    tempDate.getDate(),
                    tempDate.getHours(),
                    tempDate.getMinutes()
                )
            );
            return this.getMomentDate(this.getUTCDateString(localNativeDate));
        }
    }

    public static getNativeDate(date: moment.Moment | string): Date {
        if (date === null) {
            return null;
        }
        let momentDate: moment.Moment;
        if (typeof date === 'string') momentDate = this.getMomentDate(date);
        else momentDate = date;
        return new Date(
            momentDate.year(),
            momentDate.month(),
            momentDate.date()
        );
    }

    public static getDateDifference(fromDate: string, toDate: string): number {
        const fromMomentDate = this.getMomentDate(fromDate);
        const toMomentDate = this.getMomentDate(toDate);
        return Math.abs(
            moment.duration(toMomentDate.diff(fromMomentDate)).asDays()
        );
    }

    public static getUTCDateString(date: Date): string {
        if (date != null) {
            return `${date.getFullYear()}-${StringHelper.pad(
                date.getMonth() + 1,
                2
            )}-${StringHelper.pad(date.getDate(), 2)}`;
        }
    }
}
